import React, { useContext, useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { useHistory, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { endOfMonth, format, isBefore, isValid, parse, startOfMonth, subMonths } from 'date-fns'
import qs from 'query-string'
import useSWR from 'swr'

import Calendar from '../../../components/Calendar'
import { RootContext } from '../../../context/rootContext'
import { Container } from '../../../styles/global'
import { Title } from './styles'

const DATE_FORMAT = 'yyyy-MM-dd HH:mm'

const MonthlyView = () => {
  const history = useHistory()
  const { loadingState } = useContext(RootContext)
  const [, setLoading] = loadingState
  const [month, setMonth] = useState(new Date())

  const date = new URLSearchParams(useLocation().search).get('date')
  useEffect(() => {
    const month = parse(date, 'yyyy-MM', new Date())
    if (isValid(month)) {
      setMonth(month)
    }
  }, [date])

  const { partner, partnerName, professional: { id: professionalId } } = JSON.parse(localStorage.getItem('userData'))

  const { data: events, error: eventsError } = useSWR(() => `${process.env.REACT_APP_SCHEDULER_URL}/schedulings/professional?${qs.stringify({
    month: month.getMonth() + 1,
    year: month.getFullYear(),
    partnerId: partner,
    professionalId,
    count: true
  }, { arrayFormat: 'bracket' })}`)

  const { data: overbooks, error: overbooksError } = useSWR(() => `${process.env.REACT_APP_SCHEDULER_URL}/overbooks/professional?${qs.stringify({
    month: month.getMonth() + 1,
    year: month.getFullYear(),
    partnerId: partner,
    professionalId,
    count: true
  }, { arrayFormat: 'bracket' })}`)

  const { data: blocks, error: blocksError } = useSWR(() => `${process.env.REACT_APP_PARTNER_URL}/block/occurrences?${qs.stringify({
    from: format(startOfMonth(month), DATE_FORMAT),
    to: format(endOfMonth(month), DATE_FORMAT),
    professionalIds: [professionalId]
  }, { arrayFormat: 'bracket' })}`)

  if (eventsError) {
    Sentry.captureException(eventsError)
  }

  if (blocksError) {
    Sentry.captureException(blocksError)
  }

  if (overbooksError) {
    Sentry.captureException(blocksError)
  }

  useEffect(() => {
    setLoading(!events || !blocks)
  }, [events, blocks, setLoading])

  const onDayClick = day => {
    history.push({
      pathname: '/daily',
      search: `?date=${format(day, 'yyyy-MM-dd')}`
    })
    ReactGA.pageview(`/daily?date=${format(day, 'yyyy-MM-dd')}`)
  }

  const onMonthChange = month => {
    // Não permite que o usuário navegue por mais que um mês no passado
    if (isBefore(month, subMonths(startOfMonth(new Date()), 1))) {
      return
    }
    history.push(`/monthly?date=${month.getFullYear()}-${month.getMonth() + 1}`)
    ReactGA.pageview(`/monthly?date=${month.getFullYear()}-${month.getMonth() + 1}`)
  }

  return (
    <Container flex>
      <Title>{partnerName}</Title>
      <Calendar
        month={month}
        events={events}
        blocks={blocks}
        overbooks={overbooks}
        onDayClick={onDayClick}
        onMonthChange={onMonthChange}
      />
      <pre style={{ color: 'red' }}>{JSON.stringify(eventsError || blocksError || overbooksError, null, 2)}</pre>
    </Container>
  )
}

export default MonthlyView
